<template>
  <div class="flex flex-col gap-3">
    <p class="text-base font-semibold text-on-surface">¿En qué bus está el código?</p>
    <label class="flex h-12 items-center gap-2 rounded-xl border border-outline/50 bg-surface px-4 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
      <vs-icon name="lucide:search" :size="18" color="on-surface" class="flex-shrink-0 opacity-60" />
      <!-- Plain input: the picker owns its value (vsInput keeps its own form state). -->
      <input
        v-model="search"
        type="search"
        class="w-full bg-transparent text-lg uppercase text-on-surface outline-none placeholder:normal-case"
        placeholder="Buscar por placa"
        autocapitalize="characters"
        autocorrect="off"
        spellcheck="false"
      />
    </label>
    <p v-if="!vehicles.length" class="py-4 text-center text-base text-on-surface-variant">
      No encontramos los buses de tu empresa. Vuelve a intentarlo con señal.
    </p>
    <p v-else-if="!filtered.length" class="py-4 text-center text-base text-on-surface-variant">Ningún bus con esa placa.</p>
    <ul v-else class="-mx-1 flex max-h-72 flex-col gap-1 overflow-y-auto px-1">
      <li v-for="vehicle in filtered" :key="vehicle.id">
        <button
          type="button"
          class="flex h-12 w-full items-center justify-between rounded-xl px-4 text-left text-lg font-semibold text-on-surface active:bg-surface-variant/60"
          :class="vehicle.id === currentID ? 'bg-primary-container text-on-primary-container' : 'bg-surface-variant/30'"
          @click="$emit('pick', vehicle)"
        >
          {{ vehicle.name || 'Sin placa' }}
          <vs-icon v-if="vehicle.id === currentID" name="lucide:check" :size="20" color="primary" />
        </button>
      </li>
    </ul>
    <vs-button kind="surface" class="h-12 w-full" text="Volver" @click="$emit('cancel')" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from 'vue'
import { vsButton, vsIcon } from '@isagaco/vuesaga'
import { normalizePlate, type FleetVehicle } from '@/utils/busWalkthrough'

// The bus a walkthrough sticker is on: the customer's live vehicles as the server sent them (the app never builds the
// fleet), searched by plate. Used by the sticker's first scan and by "Corregir".
export default defineComponent({
  name: 'BusWalkthroughVehiclePicker',
  components: { vsButton, vsIcon },
  props: {
    vehicles: { type: Array as PropType<FleetVehicle[]>, required: true },
    /** The bus shown now (marked in the list). */
    currentID: { type: String as PropType<string | null>, default: null },
  },
  emits: ['pick', 'cancel'],
  setup(props) {
    const search = ref('')
    const filtered = computed(() => {
      const typed = normalizePlate(search.value)
      return typed ? props.vehicles.filter(vehicle => normalizePlate(vehicle.name || '').includes(typed)) : props.vehicles
    })
    return { search, filtered }
  },
})
</script>
